import { DataBean } from "../../DataBean";


export class PharmaPresentation extends DataBean {

    public async getPharmaPresentationCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPharmaPresentationCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}